import Item from "@/modules/file-storage/item.model";

import Plushie from "./plushie.model";

export default class PlushieStorageItemNameResolverService {
  public resolve(storageItem: Item, plushie: Plushie): string {
    let imageName = `${plushie.storeItemId}_`;

    if (storageItem.fileName) {
      imageName += `${storageItem.fileName}`;
    } else {
      imageName += `${storageItem.key}`;
    }

    return imageName;
  }
}
